import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'
const ProgressBar = ({ progress, barColor, textColor }) => {
  return (
    <Styles.ProgressBarContainer>
      <Styles.ProgressBar progress={progress} barColor={barColor} textColor={textColor}>
        <Text type="bodyMRegular">
          <FormatNumber style="percent">{progress}</FormatNumber>
        </Text>
      </Styles.ProgressBar>
    </Styles.ProgressBarContainer>
  )
}

export default ProgressBar
